module.exports = __webpack_public_path__ + "img/spin-city-tycoon-splash.0fc148ae.png";